import {Model} from 'vue-mc';
import Vue from "vue";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class bookingCountModel extends Model {

    defaults() {
        return {
            "available": 'loading',
            "available_onsite": 'loading',
            "available_telephone": 'loading',
            "available_video": 'loading',
            "confirmed": 'loading',
            "today": 'loading',
            "total": ''
        }
    }

    options() {
        return {
            methods: {
                bookingCount: 'GET'
            }
        }
    }

    routes() {
        return {
            bookingCount: 'interpreter/booking/count'
        }
    }

    getBookingCount(data) {
        let headers = {
            Bearer: localStorage.getItem('jwt')
        };
        let method = this.getOption('methods.bookingCount');
        let route = Vue.prototype.$interpretersApiUrl + this.getRoute('bookingCount');
        let params = this.getRouteParameters();
        let url = this.getURL(route, params);
        return this.getRequest({headers, method, url, data}).send();
    }
}
